import React from 'react';
import { useContext } from 'react';
import LiveLoader from './LiveLoader';
import { getConfiguration } from '../data/utils/configuration';
import { usePoll } from '../data/fetch/useFetch';
import { parseLiveData } from '../data/parseLiveData';
import { useSetSection } from '../common/SectionProvider';

export const LiveDataContext = new React.createContext(null);

export function useLiveData() {
    return useContext(LiveDataContext);
}

export default function LiveDataProviderChildren(props) {
    const conf = getConfiguration();
    useSetSection('live');

    const [, isError, data] = usePoll(conf.api.getMenuLiveSingleMatchPage, null, (data =>
        parseLiveData(data)
    ));

    if (isError) {
        return <LiveLoader isError={true} />
    }

    return (
        <LiveDataContext.Provider value={data}>
            {props.children}
        </LiveDataContext.Provider>
    );
}
